import React, {useContext} from "react";
import styled from "styled-components";

//
import CourseContext from "../../../../../context/course/CourseContext";
import CourseCard from "../components/CourseCard";
import {Link} from "react-router-dom";

export default function Course() {
    // context
    const {
        state: {loading, courses},
    } = useContext(CourseContext);

    const goToCourse = (id) => {
        console.log(id)
    }

    return (
        <StyledCourse className="courses_section" id="course__section">
            <div className="container">
                <h2 className="section_title">Курсы</h2>
                <div className="courses_row">
                    {loading ? (
                        <h1>Loading...</h1>
                    ) : (
                        courses.map((i) => (
                            <Link to={`/curse/${i.id}`}>
                                <CourseCard
                                    key={i.id}
                                    title={i.content}
                                    time={i.timeComplete}
                                    students={1440}
                                    onClick={() => goToCourse(i.id)}
                                />
                            </Link>
                        ))
                    )}
                </div>
            </div>
        </StyledCourse>
    );
}

const StyledCourse = styled.div`
  &.courses_section {
    margin-top: 96px;
  }

  .courses_row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 24px;
  }

  .courses_card {
    cursor: pointer;
    transition: 0.25s linear;
  }

  .courses_card:hover .card_title {
    color: royalblue;
  }

  .card_body {
    padding: 16px;
    background: #fff;
  }

  .card_title {
    font-size: 2rem;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 8px;
  }

  .card_info {
    color: #6c757d;
  }

  .card_info_item:first-child {
    margin-right: 24px;
  }

  .card_img {
    padding: 24px;
  }

  .x-bg-red {
    background-color: #dc3545;
  }

  @media screen and (max-width: 991px) {
    .courses_row {
      grid-template-columns: repeat(3, 1fr);
    }

    .card_title {
      font-size: calc(1.325rem + 0.9vw);
    }
  }

  @media screen and (max-width: 567px) {
    .courses_row {
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 8px;
    }
  }
`;
